import * as React from 'react';
import ManagersLeftSide from './ManagersLeftSide';
import { LoadableContent, Page, PageNavigation } from '@ui/components';
import { connect } from 'react-redux';
import { StoreState } from '@ui/store/rootReducer';
import { managersSelectors } from '..';
import * as actions from '../services/actions';
import ManagerCard from '../components/ManagerCard';

import './Managers.less';

interface StateToProps {
  loading: boolean;
  managers: any[];
}

interface DispatchToProps {
  onLoadManagers: () => void;
  onRemoveManager: (managerId: number) => void;
  setEditManager: (manager: any) => void;
}

type Props = StateToProps & DispatchToProps;

class Managers extends React.PureComponent<Props> {
  static LeftSide = ManagersLeftSide;

  componentDidMount(): void {
    const { onLoadManagers } = this.props;

    onLoadManagers();
  }

  render() {
    const { loading, managers, onRemoveManager, setEditManager } = this.props;

    return (
      <LoadableContent loading={loading}>
        <div className="managers-page">
          <PageNavigation title="Менеджеры" />
          <Page>
            <Page.LeftSide>
              <ManagersLeftSide />
            </Page.LeftSide>
            <Page.Content>
              {' '}
              <div className="managers-list">
                {managers.map((manager) => (
                  <ManagerCard
                    key={manager.id}
                    manager={manager}
                    onRemoveManager={onRemoveManager}
                    onEdit={setEditManager}
                  />
                ))}
              </div>
            </Page.Content>
          </Page>
        </div>
      </LoadableContent>
    );
  }
}

const mapStateToProps = (state: StoreState): StateToProps => ({
  loading: managersSelectors.getLoading(state),
  managers: managersSelectors.getManagers(state),
});

const mapDispatchToProps: DispatchToProps = {
  onLoadManagers: actions.managersRequested,
  onRemoveManager: actions.removeManagerSucceeded,
  setEditManager: actions.setEditManager,
};

export default connect(mapStateToProps, mapDispatchToProps)(Managers);



// WEBPACK FOOTER //
// ./src/scenes/Managers/containers/Managers.tsx